import axios from "axios";
import { Terms } from "src/pages/dashboard/TermsOfService";
import { privacy } from "src/pages/dashboard/PrivacyPolicy";

const dataConfig = {
  client_id: process.env.REACT_APP_AUTH0_MTM_CLIENT_ID,
  client_secret: process.env.REACT_APP_AUTH0_MTM_CLIENT_SECRET,
  audience: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/api/v2/`,
  grant_type: "client_credentials",
};

export const checkNavigateOrSave = () => {
  if (
    localStorage.getItem("Terms") != "undefined" &&
    localStorage.getItem("Privacy") != "undefined"
  ) {
    const { accepted_Terms, accepted_Terms_Version } = JSON.parse(
      localStorage.getItem("Terms")
    );
    const { accepted_Privacy, accepted_Privacy_Version } = JSON.parse(
      localStorage.getItem("Privacy")
    );

    let result = "";
    result =
      accepted_Privacy && accepted_Privacy_Version === privacy[0].version
        ? result === ""
          ? ""
          : result
        : "/dashboard/privacy-policy";

    result =
      accepted_Terms && accepted_Terms_Version == Terms[0].version
        ? result === ""
          ? ""
          : result
        : "/dashboard/terms-of-service";
    return result;
  } else if (localStorage.getItem("Terms") == "undefined") {
    return "/dashboard/terms-of-service";
  } else {
    return "/dashboard/privacy-policy";
  }
};

export const getUserData = (token) => {
  const tokenData = JSON.parse(atob(token.split(".")[1]));

  return axios
    .post(
      `https://${process.env.REACT_APP_AUTH0_DOMAIN}/oauth/token`,
      dataConfig,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      return axios
        .get(
          `https://${process.env.REACT_APP_AUTH0_DOMAIN}/api/v2/users/${tokenData.sub}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${response.data.access_token}`,
            },
          }
        )
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    })
    .catch((error) => {
      console.error(error);
    });
};

export const patchUserMetadata = (data, token) => {
  const tokenData = JSON.parse(atob(token.split(".")[1]));
  return axios
    .post(
      `https://${process.env.REACT_APP_AUTH0_DOMAIN}/oauth/token`,
      dataConfig,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      return axios
        .patch(
          `https://${process.env.REACT_APP_AUTH0_DOMAIN}/api/v2/users/${tokenData.sub}`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${response.data.access_token}`,
            },
          }
        )
        .then((res) => {
          return res.data;
        })
        .catch((_err) => {
          return false;
        });
    })
    .catch((error) => {
      console.error(error);
    });
};
